(() => {
  if (window.__productGallerySliderInit) return;
  window.__productGallerySliderInit = true;

  const MOBILE = '(max-width: 749px)';

  const visibleSlides = (slider) =>
    Array.from(slider.querySelectorAll('.product__media-item')).filter((item) => item.clientWidth > 0);

  const updateProgress = (component) => {
    const slider = component.querySelector('[id^="Slider-Gallery-"]');
    const progress = component.querySelector('[data-product-gallery-progress]');
    const thumb = progress?.querySelector('.product-gallery-progress__thumb');
    if (!slider || !progress || !thumb) return;

    const slides = visibleSlides(slider);
    const count = slides.length;

    if (count < 2 || !window.matchMedia(MOBILE).matches) {
      progress.hidden = true;
      return;
    }

    progress.hidden = false;
    const maxScroll = Math.max(slider.scrollWidth - slider.clientWidth, 0);
    const ratio = maxScroll > 0 ? Math.min(1, Math.max(0, slider.scrollLeft / maxScroll)) : 0;

    thumb.style.width = `${100 / count}%`;
    thumb.style.transform = `translateX(${ratio * (count - 1) * 100}%)`;
  };

  const bind = (component) => {
    if (!(component instanceof HTMLElement)) return;

    const slider = component.querySelector('[id^="Slider-Gallery-"]');
    if (!slider) return;

    if (component.dataset.galleryProgressReady !== 'true') {
      component.dataset.galleryProgressReady = 'true';

      const onUpdate = () => updateProgress(component);
      slider.addEventListener('scroll', onUpdate, { passive: true });
      component.addEventListener('slideChanged', onUpdate);
      window.addEventListener('resize', onUpdate);

      if (typeof ResizeObserver === 'function') {
        new ResizeObserver(onUpdate).observe(slider);
      }
    }

    updateProgress(component);
    requestAnimationFrame(() => updateProgress(component));
  };

  const init = () => {
    document.querySelectorAll('slider-component.product-gallery-slider').forEach(bind);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  window.initProductGallerySlider = init;

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      requestAnimationFrame(init);
    });
  }
})();
